import { shallowMount } from "@vue/test-utils";
import PhoneData from "@/components/core/PhoneData";

describe("CardProduct component", () => {
  let wrapper;

  const props = {
    value: {
      area: "223",
      numero: "4231522",
      normalizado: {
        area: "223",
        caracteristica: "601",
        nro: "7890",
        interno: "",
        valido: true
      }
    }
  };

  beforeEach(() => {
    wrapper = shallowMount(PhoneData, {
      propsData: props
    });
  });

  it("Renders del component PhoneData", () => {
    expect(wrapper).toBeDefined();
  });
});
